import React from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { config } from "../App";

const SuccessModal = ({ isOpen, onClose, message }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Success Modal"
      className="modal-sm success-modal p-5"
    >
      <div className="d-flex flex-column align-items-center">
        <div className="mb-5">
          <img
            className="icon-60"
            src="./images/icon-success.svg"
            alt="success-icon"
          />
        </div>
        <div className="mb-5">
          <p className="font-xxl extraBold text-center">{message}</p>
        </div>
        <div>
        {/* onClick={onClose} */}
        {message === 'NC Raised successfully!' ? (
          <Link to={`/${config.baseUrl}/dashboard`} className="btn btn-primary">
            <span className="font-lg font-bold px-5">OK</span>
          </Link>
        ) : message === 'ATR Submitted Successfully for review!' ? (
          <Link to={`/${config.baseUrl}/ncReport`} className="btn btn-primary">
            <span className="font-lg font-bold px-5">OK</span>
          </Link>
        ) : message === 'User added successfully!' ? (
          <Link to={`/${config.baseUrl}/users`} className="btn btn-primary">
            <span className="font-lg font-bold px-5">OK</span>
          </Link>
        ) : message === 'User data updated successfully!' ? (
          <Link to={`/${config.baseUrl}/users`} className="btn btn-primary">
            <span className="font-lg font-bold px-5">OK</span>
          </Link>
        ) :message === 'Verify & NC Raised successfully!' ? (
          <Link to={`/${config.baseUrl}/dashboard`} className="btn btn-primary">
            <span className="font-lg font-bold px-5">OK</span>
          </Link>
        ): <button type="button" className="btn btn-primary" onClick={onClose}>
        <span className="font-lg font-bold px-5">OK</span>
        </button>} 

        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
